/* eslint-disable max-len */
import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { filter } from 'rxjs/operators';
import { AppState } from 'src/app/store/app.reducer';
import * as DeviceActions from 'src/app/store/device/device.actions';
import { Observable, Subscription } from 'rxjs';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { StandardDynamicComponent, StandardNewValidator, StandardPageLayout } from 'src/app/modules/shared/stdlayoutlib/classes.stdlayoutlib';
import { CAWeekDay, CAWeeklySchedule } from 'src/app/model/control-access';
import { selectWeeklyScheduleModifing, selectWeeklyScheduleModify } from 'src/app/store/device/device.selector';
import { CustomValidators } from 'src/app/validators/custom.validators';
import moment from 'moment';

@Component({
	selector: 'app-control-access-weekly-schedule-dialog',
	templateUrl: './control-access-weekly-schedule-dialog.component.html',
})

export class ControlAccessWeeklyScheduleDialogComponent implements OnInit, OnDestroy {

	weeklyScheduleModify$: Observable<boolean | undefined>;
	weeklyScheduleModifySub: Subscription | undefined;
	weeklyScheduleModifing$: Observable<boolean | undefined>;
	weeklyScheduleModifingSub: Subscription | undefined;

	weeklySchedule: CAWeeklySchedule;
	editMode = false;
	saving = false;

	weeklyScheduleForm: FormGroup;

	editedSub: Subscription;
	addedSub: Subscription;
	groupModifySub: Subscription;
	daysOfWeek: CAWeekDay[] = [
		{ Value: '0', Name: 'MON', Enable: false },
		{ Value: '1', Name: 'TUE', Enable: false },
		{ Value: '2', Name: 'WED', Enable: false },
		{ Value: '3', Name: 'THU', Enable: false },
		{ Value: '4', Name: 'FRI', Enable: false },
		{ Value: '5', Name: 'SAT', Enable: false },
		{ Value: '6', Name: 'SUN', Enable: false },
	];

	// design
	screenWidth: number;

	constructor(
		private fb: FormBuilder,
		private store: Store<AppState>,
		private ref: DynamicDialogRef,
		public config: DynamicDialogConfig,
	) {
		this.weeklySchedule = new CAWeeklySchedule();
		if (config.data !== undefined && config.data.weeklySchedule !== undefined) {
			this.weeklySchedule.Id = config.data.weeklySchedule.Id;
			this.weeklySchedule.Name = config.data.weeklySchedule.Name;
			this.weeklySchedule.Weekdays = config.data.weeklySchedule.Weekdays;
			this.weeklySchedule.TimeFrom = config.data.weeklySchedule.TimeFrom;
			this.weeklySchedule.TimeTo = config.data.weeklySchedule.TimeTo;
			this.editMode = true;
		} else {
			this.weeklySchedule.TimeFrom = "00:00";
			this.weeklySchedule.TimeTo = "23:59";
		}
		this.initSelectors();
	}

	initSelectors(): void {
		this.weeklyScheduleModify$ = this.store.select(selectWeeklyScheduleModify);
		this.weeklyScheduleModifing$ = this.store.select(selectWeeklyScheduleModifing);
	}

	ngOnInit(): void {
		const currentWeekDays = [];
		let value = this.weeklySchedule.Weekdays;
		for (let i = 6; i > -1; i--) {
			if (value !== 0 && value / (2 ** i) >= 1) {
				currentWeekDays.unshift(i.toString());
			}
			value = value % (2 ** i);
		}
		const wDayArr = this.daysOfWeek.map((weekday) => this.fb.control(currentWeekDays.includes(weekday.Value)));
		this.weeklyScheduleForm = this.fb.group({
			'Name': new FormControl(this.weeklySchedule.Name, [Validators.required, Validators.maxLength(48)]),
			'startTime': new FormControl(this.weeklySchedule.TimeFrom, Validators.required),
			'endTime': new FormControl(this.weeklySchedule.TimeTo, Validators.required),
			'weekDays': this.fb.array(wDayArr, CustomValidators.multipleCheckboxRequireOne),
		});
		this.weeklyScheduleForm.addValidators(CustomValidators.checkCorrectTimeSequence('startTime', 'endTime'));

		this.subscribeAll();

		this.onResize();
		StandardNewValidator.setFirstCompile(true);
	}

	subscribeAll(): void {
		this.weeklyScheduleModifySub = this.weeklyScheduleModify$
			.pipe(filter(weeklyScheduleModify => !!weeklyScheduleModify))
			.subscribe(() => {
				this.resetClose();
			});
		this.weeklyScheduleModifingSub = this.weeklyScheduleModifing$
			.subscribe((editing) => {
				this.saving = editing;
			});
	}

	ngOnDestroy(): void {
		this.weeklyScheduleModifySub?.unsubscribe();
		this.weeklyScheduleModifingSub?.unsubscribe();
	}

	resetClose(): void {
		this.store.dispatch(DeviceActions.resetWeeklyScheduleForm());
		this.closeDialog();
	}

	submit(): void {
		StandardNewValidator.setFirstCompile(false);
		if (!this.getFormValidationErrors()) {
			this.save();
		}
	}

	getFormValidationErrors(): boolean {
		let atLeastOneError = false;
		Object.keys(this.weeklyScheduleForm.controls).forEach(key => {
			const controlErrors: ValidationErrors = this.weeklyScheduleForm.get(key).errors;
			if (controlErrors != null) {
				/* Object.keys(controlErrors).forEach(keyError => {
					console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
				}); */
				atLeastOneError = true;
			}
		});
		return atLeastOneError;
	}

	save(): void {
		const weeklySchedule = { ...this.weeklySchedule };
		weeklySchedule.Name = this.f.Name.value;

		// TIME START ELABORATION
		let startTimeStr = this.f.startTime.value.toString().toLowerCase()
		if (!/^\d$/.test(startTimeStr.charAt(0))) {
			// non è in formato numerico
			startTimeStr = startTimeStr.substring(16, 21)
			this.f.startTime.value = startTimeStr;
		}
		const momTimeFrom = moment().local()
			.hours(+this.f.startTime.value.split(':')[0])
			.minutes(+this.f.startTime.value.split(':')[1]);
		weeklySchedule.TimeFrom = momTimeFrom.format('HH:mm');
		// TIME START ELABORATION
		// TIME END ELABORATION
		let endTimeStr = this.f.endTime.value.toString().toLowerCase()
		if (!/^\d$/.test(endTimeStr.charAt(0))) {
			// non è in formato numerico
			endTimeStr = endTimeStr.substring(16, 21)
			this.f.endTime.value = endTimeStr;
		}
		const momTimeTo = moment().local()
			.hours(+this.f.endTime.value.split(':')[0])
			.minutes(+this.f.endTime.value.split(':')[1]);
		weeklySchedule.TimeTo = momTimeTo.format('HH:mm');
		// TIME END ELABORATION
		weeklySchedule.Weekdays = this.parseDays();

		if (this.weeklySchedule.Id) {
			this.store.dispatch(DeviceActions.editWeeklySchedule({ weeklySchedule: weeklySchedule }));
		} else {
			this.store.dispatch(DeviceActions.addWeeklySchedule({ weeklySchedule: weeklySchedule }));
		}
	}

	parseDays(): number {
		const WDControl = this.f.weekDays as FormArray;
		const days = [];
		let value = 0;
		WDControl.controls.forEach((c, i) => {
			if (c.value) {
				days.push(i);
				value = value + 2 ** i;
			}
		});
		return value;
	}

	get f(): any {
		return this.weeklyScheduleForm.controls;
	}

	closeDialog(): void {
		this.ref.close();
	}

	// Design
	@HostListener('window:resize', ['$event'])
	onResize() {
		this.screenWidth = window.innerWidth;
	}

	onExtendedMobile(): boolean {
		return StandardPageLayout.onExtendedMobile(this.screenWidth);
	}

	dynamicButtonWidth(): string {
		return StandardPageLayout.dynamicButtonWidth(this.screenWidth);
	}

	dynamicInputTextWidth(): string {
		return StandardPageLayout.dynamicInputTextWidth(this.screenWidth, 'w-23rem');
	}

	justifyContentStyle(): string {
		return StandardNewValidator.justifyMessagesNewValidator(this.screenWidth);
	}

	newShowErrors(type: ControlAccessWeeklyScheduleDialogComponent["f"], classType: string): string {
		return StandardNewValidator.newShowErrors(type, classType, this.screenWidth);
	}

	showErrorRequiredMessage(type: ControlAccessWeeklyScheduleDialogComponent["f"]): boolean {
		return StandardNewValidator.showErrorRequiredMessage(type);
	}

	simpleInputTextLayout(classType: string): string {
		return StandardPageLayout.simpleInputTextLayout(classType, this.screenWidth);
	}

	dynamicDatepicker(): string {
		return StandardDynamicComponent.dynamicDatepicker(this.screenWidth);
	}

	customPaddingX(): string {
		return StandardPageLayout.customPaddingX(this.screenWidth);
	}

	manageRespStylewithError(type: ControlAccessWeeklyScheduleDialogComponent["f"], classType: string): string {
		return StandardNewValidator.manageRespStylewithError(type, classType, this.screenWidth);
	}

	showErrorRequiredCheckBox(type: ControlAccessWeeklyScheduleDialogComponent["f"]): string {
		return StandardNewValidator.showErrorRequiredCheckBox(type);
	}

	col12Responsive(): string {
		return StandardPageLayout.col6Responsive(this.screenWidth);
	}

	dynamicInputShortTextWidth(): string {
		return StandardPageLayout.dynamicInputTextDesktopTabletWidth(this.screenWidth, 'w-20rem', 'w-23rem');
	}
}
